module.exports = __webpack_public_path__ + "static/media/trio v shot 02.74a17e4c.webp";